import { motion } from "framer-motion";
import { useEffect, useState } from "react";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Work", href: "#portfolio" },
  { label: "Featured", href: "#featured" },
  { label: "Course", href: "#course" },
  { label: "Contact", href: "#contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -40, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.2, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-[50] transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-black/40 border-b border-white/5 py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="font-display text-xl md:text-2xl font-bold tracking-tighter"
        >
          BL<span className="text-[#FD1843]">.</span>
        </a>

        <nav className="hidden md:flex items-center gap-9">
          {LINKS.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              href={l.href}
              className="relative text-[13px] tracking-tight text-white/70 hover:text-white transition-colors group"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-[#FD1843] group-hover:w-full transition-all duration-500" />
            </a>
          ))}
        </nav>

        <a
          data-testid="nav-cta-course"
          href="https://wa.me/9647825579755"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.preventDefault();
            const url = "https://wa.me/9647825579755";
            const w = window.open(url, "_blank", "noopener,noreferrer");
            if (!w) { try { window.top.location.href = url; } catch { window.location.href = url; } }
          }}
          className="text-[12px] md:text-[13px] tracking-tight font-medium px-4 py-2 rounded-full border border-white/15 hover:border-[#FD1843] hover:text-[#FD1843] transition-all"
        >
          Join Course →
        </a>
      </div>
    </motion.header>
  );
}
